import { createSlice } from '@reduxjs/toolkit';

// userSlice.js - Enhanced version
const userSlice = createSlice({
  name: 'user',
  initialState: {
    schoolId: null,
    schoolName: null,
    schoolCode: null,
    schoolLogo: null,
    role: null,
    loginTime: null,
    email: null,
    username: null,
    name: null,
    permissions: [],
    subscriptionStatus: null,
    trialEndsIn: null,
    googleDriveConnected: false,
    isOnboardComplete: null,
    hasPendingSetup: false,
    setupSkipped: false,
    pendingSetupItems: [],
  },
  reducers: {
    setSchool: (state, action) => {
      state.schoolId = action.payload.schoolId;
      state.schoolName = action.payload.schoolName;
      state.schoolLogo = action.payload.logo;
    },
    setLoginTime: (state, action) => {
      state.loginTime = action.payload;
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
    setGoogleDriveConnected: (state, action) => {
      state.googleDriveConnected = Boolean(action.payload);
    },
    setUserData: (state, action) => {
      // Save everything from the API response
      state.schoolId = action.payload.schoolId;
      state.schoolName = action.payload.schoolName;
      state.schoolCode = action.payload.schoolCode;
      state.schoolLogo = action.payload.schoolLogo;
      state.role = action.payload.role;
      state.email = action.payload.email;
      state.username = action.payload.username;
      state.name = action.payload.name;
      state.permissions = action.payload.permissions || [];
      state.subscriptionStatus = action.payload.subscriptionStatus;
      state.trialEndsIn = action.payload.trialEndsIn;
      state.googleDriveConnected = action.payload.googleDriveConnected;
      state.isOnboardComplete = action.payload.isOnboardComplete ?? null;
      state.hasPendingSetup = action.payload.hasPendingSetup ?? false;
      state.setupSkipped = action.payload.setupSkipped ?? false;
      state.pendingSetupItems = action.payload.pendingSetupItems ?? [];
    },
    clearUserData: (state) => {
      state.schoolId = null;
      state.schoolName = null;
      state.schoolCode = null;
      state.schoolLogo = null;
      state.role = null;
      state.email = null;
      state.username = null;
      state.name = null;
      state.permissions = [];
      state.subscriptionStatus = null;
      state.trialEndsIn = null;
      state.googleDriveConnected = false;
      state.isOnboardComplete = null;
      state.hasPendingSetup = false;
      state.setupSkipped = false;
      state.pendingSetupItems = [];
    }
  }
});

export const { setSchool, setRole, setUserData, clearUserData, setLoginTime, setGoogleDriveConnected } = userSlice.actions;
export default userSlice.reducer;


